import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { language } from "../../stores/slices/languageSlice";
import {
  requiredActions,
  updateAllActionData,
  setViewAllFlage,
  fetchRequiredActionsCPR,
  fetchRequiredActionsFAF,
  updateRequiredActionFlage,
} from "../../stores/slices/requiredActionsSlice";
import SvgLoader from "../menu/SvgLoader";
import { fetchViewAppDetails, getMemberDetails, resetInitialTab } from "../../stores/slices/appViewDetailsSlice";

function RequiredActions() {
  const dispatch = useDispatch();
  const [requirdActionData, setRequirdActionData] = useState([]);
  const [firstFiveData, setFirstFiveData] = useState([]);
  const selectedLanguage = useSelector(language).Dashboard.requiredActions;
  const requirdActionsData = useSelector(
    (state) => state.requiredActionsSlice.requirdAction
  );
  const loginStatus = useSelector((state) => state.loginSlice);
  const navigate = useNavigate();
  useEffect(() => {
    let sortList = [];
    // Sort the array by DueDate
    let listCPR = JSON.stringify(requirdActionsData.requiredActionsValueCPR);
    listCPR = JSON.parse(listCPR);
    let listFAF = JSON.stringify(requirdActionsData.requiredActionsValueFAF);
    listFAF = JSON.parse(listFAF);
    sortList = listCPR.concat(listFAF);
    sortList.sort(function (a, b) {
      var dateA = new Date(a.DueDate);
      var dateB = new Date(b.DueDate);
      return dateA - dateB;
    });

    setRequirdActionData(sortList);

    var firstFiveObjects = sortList.slice(0, 5);
    setFirstFiveData(firstFiveObjects);
  }, [requirdActionsData]);
  useEffect(() => {
    dispatch(fetchRequiredActionsCPR({ Program: 'CPR', EIN: loginStatus.value.EIN }))
    dispatch(fetchRequiredActionsFAF({ Program: 'FAF', EIN: loginStatus.value.EIN }))
  }, [])
  const viewAllFun = () => {
    dispatch(updateAllActionData(requirdActionData));
    dispatch(setViewAllFlage(true));
  };
  const ApplicationDetails = (e, data, parameter) => {
    if (parameter == "actionrequired") {
      let appID = data.ApplicationID
      let Program = ''
      if (data.ApplicationID.includes("FAF")) {
        Program = 'FAF'
      } else {
        Program = 'CPR'
      }
      let actionDes = data.ActionDescription;
      if (actionDes.search("Diagnosis") != -1 || 0) {
        dispatch(fetchViewAppDetails({ applicationID: appID, prgData: Program }))
        dispatch(getMemberDetails({ memberId: data.memberID, prgData: Program }))
        //  go to document page
        dispatch(resetInitialTab(5));
        navigate('/applications/Details')
      }
      if (actionDes.search("Claim") != -1 || 0) {
        dispatch(fetchViewAppDetails({ applicationID: appID, prgData: Program }))
        dispatch(getMemberDetails({ memberId: data.memberID, prgData: Program }))
        //  go to Claim page
        dispatch(resetInitialTab(7));
        navigate('/applications/Details')

      }
      else {
        dispatch(fetchViewAppDetails({ applicationID: appID, prgData: Program }))
        dispatch(getMemberDetails({ memberId: data.memberID, prgData: Program }))
        //  go to document page
        dispatch(resetInitialTab(5));
        navigate('/applications/Details')
      }
    }
  };
  return (
    <div className="g-col-12 mt-6">
      <div className="action_container">
        <div
          className="intro-y overflow-auto overflow-lg-visible mt-8 mt-sm-0 p-4 col-md-6 shadow-lg"
          style={{
            width: "100%",
            backgroundColor: "#ffff",
            borderRadius: "5px",
          }}
        >
          <h2
            className="truncate me-5"
            style={{ fontSize: "18px", fontWeight: "700" }}
          >
            {selectedLanguage.heading}
          </h2>
          {requirdActionsData?.actionLoader ? (
            <>
              {" "}
              <div
                className="text-center justify-content-end pt-3"
                style={{ height: "50vh" }}
              >
                <SvgLoader isLoader={false} />
              </div>
            </>
          ) : (
            <>
              {firstFiveData.length < 1 ? (
                <>
                  <div className="text-center noAction_container">
                    <p className="noAction_text"> No Actions found!</p>
                  </div>
                </>
              ) : (
                <>
                  <table class="table table-report mt-sm-2">
                    <thead className="bg_white">
                      <tr>
                        <th
                          class="text-nowrap"
                          style={{ display: "none" }}
                        ></th>
                        <th class="text-center text-nowrap fs-sm fw-medium ">
                          {selectedLanguage.serviceType}
                        </th>
                        <th class="text-center text-nowrap fs-sm fw-medium ">
                          {selectedLanguage.ref}
                        </th>
                        <th class="text-center text-nowrap fs-sm fw-medium ">
                          {selectedLanguage.patient}
                        </th>
                        <th class="text-center text-nowrap fs-sm fw-medium ">
                          {selectedLanguage.action}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {firstFiveData.map((data, index) => {
                        return (
                          <>
                            <tr id="action_tr" key={index}>
                              <td style={{ display: "none" }}>
                                <a href="" className="fw-medium text-nowrap">
                                  test
                                </a>
                                <div className="text-gray-600 fs-xs text-nowrap mt-0.5">
                                  test
                                </div>
                              </td>
                              <td className="text-center">
                                {data.ApplicationID.includes("FAF") ? "FAF" : "TotalAssist"}
                              </td>
                              <td className="text-center">
                                {data.ActionDescription}
                              </td>
                              <td className="text-center ActionPatientName">
                                {" "}
                                {data.PatientName == " " ||
                                  typeof data.PatientName == "undefined"
                                  ? "--"
                                  : data.PatientName}
                              </td>
                              <td className="table-report__actionm text-center pt-4">
                                <span
                                  className="completAction pointer"
                                  onClick={(e) =>
                                    ApplicationDetails(
                                      e,
                                      data,
                                      "actionrequired"
                                    )
                                  }
                                >
                                  Complete Action
                                </span>
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                  <div className="d-flex justify-content-center">
                    <div
                      className="text-center p-2  viewAll"
                      onClick={viewAllFun}
                    >
                      {"View All >>"}{" "}
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default RequiredActions;
